export default "__VITE_ASSET__BAxje$Di__"